import React, { useEffect, useState, useRef } from "react";
import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import { getValue } from "@utils/lodash";
//import { adminGetUsers } from '@services/users.service';
//import moment from 'moment';
import { adminUpdateBulkStatusCheckpoint } from "@services/checkpoint.service";
import { useNavigate, useParams } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import DataTable from "@components/DataTable/index";
import PaginationPage from "@components/pagination/pagination";
import Notfound from "@components/Not-Found";
import VendorListNavigation from "@components/Vendors/vendorlist-navigation";
import Search from "@components/common/Search";
import { Label, Modal, ModalBody } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import {
  clientCreateHeadCount,
  clientDeleteBulkHeadCount,
  clientDeleteSpecificHeadCount,
  clientGetHeadcount,
  clientUpdateSpecificHeadCount,
} from "@services/vendors.service";
import SimpleReactValidator from "simple-react-validator";
import { clientGetLocation } from "@services/location.service";
import "./index.scss";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import ScrollableReactTable from "@components/ScrollableDatatable";
import NoAccessPage from "@components/common/NoAccess";
import { sanitizeInput } from "@_common/dompurify";
interface IVendorsDetailInfoUsersProps {}

const VendorsHeadCount: React.FunctionComponent<IVendorsDetailInfoUsersProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let orgParams = useParams();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);

  const [months] = useState([
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ]);

  const [monthsArray] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  const [years, setYears] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState<any>("");

  const [selectedMonth, setSelectedMonth] = useState<any>("");
  const [selectedYear, setSelectedYear] = useState<any>("");

  const [isLoading, setIsLoading] = React.useState(true);
  const [loading, setLoading] = useState(false);
  const [list, setList] = React.useState<[]>([]);
  const [locationList, setLocationList] = useState([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const handleModalCancel = () => {
    setIsOpen(!isOpen);
    reset();
    // setEdit(false);
    // setEditId("");
    // setGroup_name("");
  };

  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const handleModalEdit = (item: object) => {
    setEdit(true);
    setRequest({
      ...request,
      headcount: getValue(item, `original.headcount`, ""),
      pe_male: getValue(item, `original.pe_male`, ""),
      pe_female: getValue(item, `original.pe_female`, ""),
      month: getValue(item, `original.month`, ""),
      year: getValue(item, `original.year`, ""),
    });
    let month = months.filter(
      (items: object) =>
        getValue(items, `value`, "") == getValue(item, `original.month`, "")
    );
    let year = years.filter(
      (items: object) =>
        getValue(items, `value`, "") == getValue(item, `original.year`, "")
    );
    let location = locationList.filter(
      (items: object) =>
        getValue(items, `id`, "") == getValue(item, `original.location.id`, "")
    );
    setSelectedMonth(getValue(month, `length`, 0) > 0 ? month[0] : {});
    setSelectedYear(getValue(year, `length`, 0) > 0 ? year[0] : {});
    // setSelectedLocation(getValue(location, `length`, 0) > 0 ? location[0] : {});
    setEditId(getValue(item, `original.id`, ""));
    handleModal();
  };

  const [request, setRequest] = useState<any>({
    headcount: "",
    pe_male: "",
    pe_female: "",
    month: "",
    year: "",
    vendor_id: orgParams.id,
  });
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
    getLocationData("");
    let currentYear = 2022;
    let count = 2022 + 4;
    let yearList: any = [];
    Array.from({ length: count }, (v, k) => k).map((k) => {
      if (k >= currentYear) {
        return yearList.push({
          value: `${k}`,
          label: `${k}`,
        });
      }
    });
    setYears(yearList);
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      vendor_id: orgParams.id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await clientGetHeadcount(queryRequest);
      if (resp) {
        setIsLoading(false);
        setList(
          getValue(resp, `data.headcounts`, []).map((item: object) => ({
            ...item,
            yearMonth:
              monthsArray[parseInt(getValue(item, `month`, "")) - 1] +
              " - " +
              getValue(item, `year`, ""),
            location_name: getValue(item, `location.location_name`, ""),
            vendor_name: getValue(item, `vendor.vendor_name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleChangeActiveStatus = async () => {
    try {
      let resp = await adminUpdateBulkStatusCheckpoint({
        ids: selectedIDs,
        is_active: false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      }
    } catch (error) {}
  };

  const calculateHeadCount = () => {
    let headcount = getValue(request, `headcount`, 0)
      ? parseInt(getValue(request, `headcount`, 0))
      : (getValue(request, `pe_male`, 0)
          ? parseInt(getValue(request, `pe_male`, 0))
          : 0) +
        (getValue(request, `pe_female`, 0)
          ? parseInt(getValue(request, `pe_female`, 0))
          : 0);
    return headcount ? headcount : 0;
  };

  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      if (calculateHeadCount() > 0) {
        if (
          calculateHeadCount() ===
          parseInt(getValue(request, `pe_male`, 0)) +
            parseInt(getValue(request, `pe_female`, 0))
        ) {
          let payload = {
            headcount: calculateHeadCount(),
            pe_male: parseInt(getValue(request, `pe_male`, 0)),
            pe_female: parseInt(getValue(request, `pe_female`, 0)),
            month: parseInt(selectedMonth.value),
            year: parseInt(selectedYear.value),
            location_id: selectedLocation.id,
            vendor_id: orgParams.id,
          };
          if (!edit) {
            try {
              let resp = await clientCreateHeadCount(payload);
              if (resp) {
                toast.success(getValue(resp, `message`, ""));
                handleModal();
                getData();
                reset();
                // setGroup_name("");
                // setEdit(false);
                // setEditId("");
              }
            } catch (error) {}
          } else {
            try {
              let resp = await clientUpdateSpecificHeadCount(editId, payload);
              if (resp) {
                toast.success(getValue(resp, `message`, ""));
                handleModal();
                reset();
                getData();
              }
            } catch (error) {}
          }
        } else {
          toast.error("Male + Female and Total Headcount should be equal");
        }
      } else {
        toast.error("Headcount is mandatory field");
      }
    }
  };

  const reset = () => {
    setEdit(false);
    setRequest({
      ...request,
      headcount: "",
      pe_male: "",
      pe_female: "",
      month: "",
      year: "",
    });
    setSelectedMonth("");
    setSelectedYear("");
    setSelectedLocation("");
    setEditId("");
  };

  const getLocationData = async (id: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setLoading(true);
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: 10,
      search_text: params.search_text,
      sort_by: params.sort_by,
      is_active: true,
      id: id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        setLoading(false);
        let filtered = getValue(resp, `data.locations`, []).map(
          (item: object) => ({
            ...item,
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            city_name: getValue(item, `city.name`, ""),
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          })
        );
        if (id) {
          setSelectedLocation(filtered[0]);
        }
        setLocationList(getValue(filtered, `length`, 0) > 0 ? filtered : []);

        // setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];

    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");

  const handleDeleteBulk = async () => {
    try {
      let resp = await clientDeleteBulkHeadCount({ ids: selectedIDs });
      if (resp) {
        toast.success("Deleted successfully");
        getData();
      }
    } catch (error) {}
  };
  const handleDeleteFun = (e: any, id: string, value: string) => {
    e.stopPropagation();
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await clientDeleteSpecificHeadCount(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.status = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: sanitizeInput(value),
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/checkpoint/active-detail/${id}`);
  };
  const rowClick = (obj: object) => {
    getLocationData(getValue(obj, `original.location.id`, ""));
    handleModalEdit(obj);
  };
  const rowClickUpdate = () => {};
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const columns: any = React.useMemo(
    () => [
      {
        Header: "Vendor",
        accessor: "vendor_name",
        width: 250,
      },
      {
        Header: "Location",
        accessor: "location_name",
        width: 250,
      },
      {
        Header: "Male Head Count",
        accessor: "pe_male",
        width: 150,
      },
      {
        Header: "Female Head Count",
        accessor: "pe_female",
        width: 150,
      },
      {
        Header: "Total Head Count",
        accessor: "headcount",
        width: 150,
      },
      {
        Header: "Month",
        accessor: "yearMonth",
        width: 150,
      },
      // 		 {
      //   	Header: "Action",
      //   	width: 200,
      //   	Cell: ({ row }: any) => {
      //   		return (
      //   			<>
      //   				<Button
      //   					color="primary"
      //   					onClick={() => handleEdit(row.original.id)}
      //   				>
      //   					Edit
      //   				</Button>
      //   				&nbsp;&nbsp;&nbsp;
      //   				<Button
      //   					color="danger"
      //   					onClick={(e) =>
      //   						handleDeleteFun(
      // 							  e,
      //   							row.original.id,
      //   							row.values.location_name
      //   						)
      //   					}
      //   				>
      //   					Delete
      //   				</Button>
      //   			</>
      //   		);
      //   	},
      //   },
    ],
    []
  );

  const handleAdd = async (value: object) => {
    setSelectedLocation(value);
  };

  const handleChangeSelect = async (e: object, value: string) => {
    // setValue(request,`[${value}]`,getValue(e,`value`,''))
    if (value === "month") {
      setSelectedMonth(e);
    } else {
      setSelectedYear(e);
    }
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const calculateTotal = () => {
    setRequest({
      ...request,
      headcount:
        (getValue(request, `pe_male`, 0)
          ? parseInt(getValue(request, `pe_male`, 0))
          : 0) +
        (getValue(request, `pe_female`, 0)
          ? parseInt(getValue(request, `pe_female`, 0))
          : 0),
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                      New Location Search Section                           */
  /* -------------------------------------------------------------------------- */

  const [searchLoading, setSearchLoading] = useState(false);
  const handleTriggerAPI = async (value: string) => {
    let payload: any = {
      page_no: 1,
      page_size: 10,
      is_active: true,
      search_text: value,
    };
    setSearchLoading(true);
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        setLocationList(
          getValue(resp, `data.locations`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          }))
        );
        setSelectedLocation("");
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };
  const handleClick = (e: any) => {
    setSelectedLocation(e);
    handleAdd(e);
    // handleSelectLocation(e);
  };
  return (
    <Layout>
      <VendorListNavigation id={orgParams.id} parentId={orgParams.parentId} />
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "configuration_vendor"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="admin-wrapper position-relative pt-5 mt-1">
            {getValue(selectedIDs, `length`, 0) > 0 && (
              <NavigationBar
                selectedIDs={selectedIDs}
                // isMarkInactiveSectionVisible={
                //   getValue(props, `permissions`, []).includes("update")
                //     ? true
                //     : false
                // }
                handleChangeActiveStatus={handleChangeActiveStatus}
                text={"MARK INACTIVE"}
                handleRemoveNavItems={handleRemoveNavItems}
                handleDeleteFun={handleDeleteBulk}
                delete={
                  getValue(props, `permissions`, []).includes("delete")
                    ? true
                    : false
                }
              />
            )}
            <div className="admin-wrapper position-relative dashboard-wrapper__header">
              <section className="add-filter-wrapper add-filter-wrapper--border w-100 d-flex align-items-center justify-content-between p-3">
                {getValue(props, `permissions`, []).includes("create") ? (
                  <div
                    className="add-filter-wrapper__add d-flex align-items-center justify-content-center"
                    onClick={handleModal}
                  >
                    {
                      <a>
                        <div className="add-filter-wrapper__add-icon d-flex align-items-center justify-content-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            width="24"
                          >
                            <path
                              d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                              fill="#ffffff"
                            />
                          </svg>
                        </div>
                      </a>
                    }
                  </div>
                ) : (
                  <p>.</p>
                )}
                <div className="add-filter-wrapper__filter d-flex align-items-center">
                  <Search
                    searchInput={search_text}
                    showSearchTextbox={showSearchTextbox}
                    toggleSearch={toggleSearch}
                    toggleSearchClose={toggleSearchClose}
                    handleChangeSearch={handleChangeSearch}
                  />
                </div>
              </section>
            </div>
            {isLoading ? (
              <Loader />
            ) : list.length > 0 ? (
              getValue(props, `permissions`, []).includes("update") ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClickUpdate}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              )
            ) : (
              <>
                {Object.keys(params).length !== 0 ? (
                  <>
                    <Notfound />
                  </>
                ) : (
                  <Notfound />
                )}
              </>
            )}
          </div>
          <div className="footer-wrapper d-flex justify-content-between mt-3">
            {list.length > 0 && (
              <img
                src="/images/building-illustration.svg"
                className="img-fluid"
              />
            )}
            {totalCount > 10 ? (
              <PaginationPage
                totalCount={totalCount}
                limit={limit}
                pageNumber={page_no}
                handleChangePagination={handleChangePagination}
                handleChangeLimit={handleChangeLimit}
              />
            ) : (
              <p className="show-rows-count mt-3 d-flex">
                Total Count:&nbsp;&nbsp;{" "}
                <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
              </p>
            )}
          </div>
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
          <Modal
            centered
            isOpen={isOpen}
            className="headcount-popup-wrapper"
            // toggle={isOpen}
          >
            <ModalBody>
              <div className="headcount-popup-wrapper__image">
                <img
                  src="/images/popup/popup-illustration.svg"
                  className="img-fluid"
                />
              </div>
              <h3 className="headcount-popup-wrapper__title text-center">
                Headcount
              </h3>
              <div className="headcount-popup-wrapper__form">
                <div className="headcount-popup-wrapper__form-group">
                  <Label>Male Headcount</Label>
                  <InputField
                    inputType="NUMBER"
                    value={getValue(request, `pe_male`, "")}
                    onChange={(e: any) => handleChangeText(e)}
                    name="pe_male"
                    id="pe_male"
                    placeholder={"Enter Male Header Count"}
                    // validator={simpleValidator}
                    label={"Male Headcount"}
                  />
                </div>
                <div className="headcount-popup-wrapper__form-group">
                  <Label>Female Headcount</Label>
                  <InputField
                    inputType="NUMBER"
                    value={getValue(request, `pe_female`, "")}
                    onChange={(e: any) => handleChangeText(e)}
                    name="pe_female"
                    id="pe_female"
                    placeholder={"Enter Female Header Count"}
                    // validator={simpleValidator}
                    label={"pe_female"}
                  />
                </div>
                <div className="headcount-popup-wrapper__form-group">
                  <Label className="d-flex">
                    Total Headcount &nbsp;{" "}
                    <p
                      style={{ color: "#276ef1", cursor: "pointer" }}
                      onClick={calculateTotal}
                    >
                      ( Click to Update Male+Female )
                    </p>
                  </Label>
                  <InputField
                    inputType="NUMBER"
                    value={getValue(request, `headcount`, "")}
                    onChange={(e: any) => handleChangeText(e)}
                    name="headcount"
                    id="headcount"
                    placeholder={"Enter Header Count"}
                    // validator={getValue(request, `pe_female`, "") || getValue(request, `pe_male`, "")?'':simpleValidator}
                    label={"Headcount"}
                    disabled={
                      getValue(request, `pe_female`, "") ||
                      getValue(request, `pe_male`, "")
                    }
                  />
                </div>
                <div className="headcount-popup-wrapper__form-group">
                  <Label className="headcount-popup-wrapper__form-label">
                    Month
                  </Label>
                  <InputField
                    inputType="INPUT_REACT_SELECT"
                    value={selectedMonth}
                    placeholder="Select"
                    options={months}
                    onChange={(e: any) => handleChangeSelect(e, "month")}
                    label="Month"
                    validator={simpleValidator}
                    className="headcount-popup-wrapper__select"
                  />
                </div>
                <div className="headcount-popup-wrapper__form-group">
                  <Label className="headcount-popup-wrapper__form-label">
                    Year
                  </Label>
                  <InputField
                    inputType="INPUT_REACT_SELECT"
                    value={selectedYear}
                    placeholder="Select"
                    options={years}
                    onChange={(e: any) => handleChangeSelect(e, "year")}
                    label="Year"
                    validator={simpleValidator}
                    className="headcount-popup-wrapper__select"
                  />
                </div>
                <div className="headcount-popup-wrapper__form-group">
                  <Label className="headcount-popup-wrapper__form-label">
                    Location
                  </Label>
                  {/* <InputField
								inputType="INPUT_REACT_SELECT"
								value={selectedLocation}
								placeholder="Select"
								options={locationList}
								onChange={(e: any) => handleAdd(e)}
								label="Location"
								validator={simpleValidator}
								className="headcount-popup-wrapper__select"
							/> */}
                  <SearchableDropdownSelect
                    placeholder={"Search Location"}
                    options={locationList}
                    searchLoading={searchLoading}
                    handleChange={(val: any) => handleTriggerAPI(val)}
                    handleClick={handleClick}
                    value={selectedLocation}
                    label="label"
                    id="id"
                    name="Location"
                    validator={simpleValidator}
                  />
                </div>
              </div>
              <div className="add-popup-wrapper__cta-wrapper pb-4 mt-3">
                <button
                  onClick={handleModalCancel}
                  className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
                >
                  Cancel
                </button>
                <button
                  className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
                  onClick={handleSubmit}
                >
                  {edit ? "Update" : "Submit"}
                </button>
              </div>
            </ModalBody>
          </Modal>
        </>
      )}
    </Layout>
  );
};

export default VendorsHeadCount;
